export enum PaymentType {
  BANK = 'BANK',
  CARD = 'CARD',
  KLARNA = 'KLARNA',
  SWISH = 'SWISH',
  CREDIT_INVOICE = 'CREDIT_INVOICE',
  MANUAL = 'MANUAL',
  WRITE_OFF = 'WRITE_OFF',
  DIRECT_BANK = 'DIRECT_BANK',
  POS = 'POS',
  REBALANCED = 'REBALANCED',
}
